<template>
  <div v-cloak class="Datum">
    <!-- 头部banner图 -->
    <div class="swiper">
      <div class="toptexts">
        <div class="imgtitle">服务中心</div>
        <div class="texts">提供专业评估反馈，共享优秀创作资源</div>
      </div>
    </div>

    <!-- 中间内容 -->
    <div class="containers">
      <div class="pa-t-30"><Bread :list="breadList" /></div>
      <div class="flex ma-t-30 bg-fff c-8a pa-l-10">
        <div
          class="pointer ma-r-50 ma-t-10 w-s-n"
          :class="0 == queryList.categoryId ? 'curStyle' : ''"
          @click="typeSwitch1(0, [])"
        >
          全部
        </div>
        <div class="flex f-wrap">
          <div
            v-for="(item, index) in typeList1"
            :key="index"
            class="ma-r-50 pointer ma-t-10"
            :class="item.Id == queryList.categoryId ? 'curStyle' : ''"
            @click="typeSwitch1(item.Id, item.Children)"
          >
            {{ item.Name }}
          </div>
        </div>
      </div>
      <div class="flex ma-t-10 c-8a ma-l-10">
        <div
          class="pointer"
          :class="0 == queryList.sortType ? 'curStyle' : ''"
          @click="bysortType(0)"
        >
          默认
        </div>
        <div
          class="pointer ma-l-50"
          :class="1 == queryList.sortType ? 'curStyle' : ''"
          @click="bysortType(1)"
        >
          日期
        </div>
        <div
          class="pointer ma-l-50"
          :class="2 == queryList.sortType ? 'curStyle' : ''"
          @click="bysortType(2)"
        >
          热度
        </div>
      </div>
      <div class="flex ma-t-10 c-8a">
        <div
          class="ma-l-10 c-pointer"
          @click="
            queryList.isstar = 0;
            loadDataList();
          "
          :class="queryList.isstar == 0 ? 'curStyle' : ''"
        >
          全部
        </div>
        <div
          class="ma-l-50 c-pointer"
          @click="
            queryList.isstar = 1;
            loadDataList();
          "
          :class="queryList.isstar == 1 ? 'curStyle' : ''"
        >
          星标
        </div>
      </div>

      <!-- 服务中心 -->
      <div class="three_box ma-center">
        <div class="flex f-center f-wrap ma-t-40 f-between">
          <div
            class="datum-boxs ma-t-30 height302"
            v-for="(item, index) in dataList"
            :key="index"
            @click="toPage('read',{id:item.Id})"
          >
            <!-- <img :src="item.Image" class="img_263" /> -->

            <div class="t-omit-2 ma-t-10 fon-14 weight500 height40">
              {{ item.Name }}
            </div>
            <div class="c-8a ma-t-12 fon-12 flex f-between">
              {{ item.ReleaseTime }}
              <div class="c-8a fon-12 flex f-center">
                {{ item.ViewCount }}人浏览
              </div>
            </div>
          </div>
        </div>
        <div v-if="dataList && dataList.length == 0" class="width100">
          <div class="t-center ma-t-40">
            <img src="../img/empty.png" alt="" srcset="" width="200" />
            <div class="c-999">暂无数据</div>
          </div>
        </div>
      </div>
      <div class="fy">
        <el-pagination
          @current-change="handleCurrentChange"
          :hide-on-single-page="true"
          :current-page.sync="queryList.pageIndex"
          :page-size="queryList.pageSize"
          layout="prev, pager, next, jumper"
          :total="totals"
        ></el-pagination>
      </div>
    </div>
  </div>
</template>
<style lang="scss"  scoped>
.height40 {
  height: 36px;
}
.ma-r-50 {
  margin-right: 50px;
}
.o-x-scroll {
  overflow-x: scroll;
}
.o-x-auto {
  overflow-x: auto;
}
.w-s-n {
  white-space: nowrap;
}
.ma-l-88 {
  margin-left: 88px;
}
.fy {
  display: flex;
  justify-content: center;
  align-items: center;
}
.height100 {
  height: 100%;
}
.box-imgwrap {
  overflow: hidden;
  height: 200px;
}
.containers {
  width: 1200px;

  margin: 0 auto 30px auto;
  padding: 0px 14px 25px 14px;
  box-sizing: border-box;
  background: #fff;
}
.curStyle {
  font-weight: 700;
  color: #fb004d;
}
.pointer {
  cursor: pointer;
}
.w-30 {
  width: 30%;
}
.Datum .swiper {
  width: 100%;
  height: 314px;
  background-image: url(../img/方案.png);
  background-size: 100% 100%;
  background-repeat: no-repeat;
  position: relative;
  .toptexts {
    width: 736px;
    position: absolute;
    top: 28%;
    margin: 0 auto;
    left: 50%;
    margin-left: -368px;
    font-size: 20px;
    font-family: MicrosoftYaHei-Bold, MicrosoftYaHei;

    color: #fff;
    opacity: 0.75;
    text-align: center;
    .texts {
      line-height: 30px;
      letter-spacing: 3px;
      font-size: 16px;
    }
    .imgtitle {
      font-size: 24px;
      font-weight: bold;
      margin-bottom: 20px;
    }
  }
}
.f-wrap {
  flex-wrap: wrap;
}
.ma-t-12 {
  margin-top: 12px !important;
}
.three_box {
  width: 100%;
  height: auto;
  margin-top: 36px;
  .datum-boxs {
    width: 100%;
    margin: 0 auto;
    border-bottom: 1px solid #e6e6e6;
    padding-bottom: 10px;
    cursor: pointer;
  }
  .boxs {
    width: 240px;
    height: 302px;
    background: #ffffff;
    box-shadow: 0px 0px 12px 0px rgba(0, 0, 0, 0.2);
    border-radius: 10px;
    position: relative;
    .img_263 {
      width: 240px;
      height: 220px;
    }
    .img_30 {
      width: 30px;
      height: 30px;
      border-radius: 50%;
      position: absolute;
      top: 205px;
      left: 10px;
    }
  }
}
</style>
<script>
import Bread from "../components/Bread.vue";
import { getType, getDatumList } from "../api";
// Import Swiper Vue.js components

// studycollect
export default {
  name: "About",
  components: {
    Bread,
  },
  data() {
    return {
      totals: 0, //一个分类下的总条数
      breadList: [
        {
          name: "服务中心",
          path: "/Datum",
        },
      ],
      typeList1: [],
      typeList2: [],
      dataList: [],
      queryList: {
        categoryId: 0, //分类id，为0时查询全部
        categoryId2: 0, //分类id，为0时查询全部
        title: "",
        sortType: 0, //排序类型 0 默认 1 日期 2 热度
        pageIndex: 1,
        pageSize: 10,
        isstar: 0,
      },
    };
  },

  created() {},
  beforeRouteEnter(to, from, next) {
    next();
  },

  // 其他页面进来时更新初始数据
  activated() {},
  computed: {},
  mounted() {
    this.info();
  },

  methods: {
    // 当前页改变时触发
    handleCurrentChange(e) {
      console.log(e);
      this.queryList.pageIndex = e;
      this.loadDataList();
    },
    //修改搜索条件
    typeSwitch1(index, Children) {
      this.queryList.categoryId = index;
      this.queryList.categoryId2 = 0;
      this.typeList2 = Children;
      this.loadDataList();
    },
    //修改搜索条件
    typeSwitch2(index) {
      this.queryList.categoryId2 = index;
      this.loadDataList();
    },
    //修改搜索条件,是否星标
    isstarChange() {
      this.queryList.isstar = this.queryList.isstar == 1 ? 0 : 1;
      this.loadDataList();
    },
    info() {
      getType().then((res) => {
        this.typeList1 = res.data.Data;
      });
      this.loadDataList();
    },
    //修改搜索条件
    bysortType(sortType) {
      this.queryList.sortType = sortType;
      this.loadDataList();
    },
    //获取列表数据
    loadDataList() {
      getDatumList(this.queryList).then((res) => {
        this.dataList = res.data.Data.List;
        //更新页码
        this.totals = res.data.Data.TotalCount;
      });
    },
    toPage(f, p) {
      switch (f) {
        case "read":
          this.$router.push({
            path: "/read",
            query: { id: p.id },
          });
          break;

        default:
          break;
      }
    },
  },
};
</script>
